// extracted by mini-css-extract-plugin
export default {"root":"C5KjeprFpP","root_large":"XFlkGstIpP","divider":"R_savpK7mf"};